<template>
  <nav class="fixed inset-x-0 bottom-0 z-30 flex h-16 gap-1.5 border-t border-default bg-default px-2 pt-1.5 pb-[max(0.375rem,env(safe-area-inset-bottom))] lg:hidden">
    <RouterLink
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="flex flex-1 flex-col items-center justify-center rounded-xl text-[11px] font-semibold text-toned"
      :active-class="item.exact ? '' : item.activeClass"
      :exact-active-class="item.activeClass"
    >
      <UIcon :name="item.icon" class="size-5" />
      <span class="leading-tight">{{ item.label }}</span>
      <span v-if="item.sub" class="text-[10px] leading-tight font-bold uppercase">{{ item.sub }}</span>
    </RouterLink>

    <button
      type="button"
      class="flex flex-1 flex-col items-center justify-center rounded-xl text-[11px] font-semibold text-toned"
      @click="menuOpen = true"
    >
      <UIcon name="i-lucide-menu" class="size-5" />
      <span class="leading-tight">{{ t('nav.menu') }}</span>
    </button>
  </nav>

  <USlideover v-model:open="menuOpen" side="left" :title="t('nav.main_menu')" :description="t('nav.main_menu_hint')">
    <template #body>
      <div class="flex min-h-full flex-col gap-4">
        <NavMenu @navigate="menuOpen = false" />
        <div class="mt-auto">
          <SessionCard />
        </div>
      </div>
    </template>
  </USlideover>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { useAppStore } from '@/stores/app'
import NavMenu from './NavMenu.vue'
import SessionCard from './SessionCard.vue'

const { t } = useI18n()
const route = useRoute()
const appStore = useAppStore()

const menuOpen = ref(false)

// Domov | Nov vnos Ročno | Nov vnos Linija | Meni. Full class strings so Tailwind sees them.
const items = computed(() => [
  { to: '/', label: t('nav.home'), sub: '', icon: 'i-lucide-house', activeClass: 'bg-elevated! text-highlighted!', exact: true },
  { to: '/rocno/nov', label: t('nav.entry'), sub: t('modules.rocno'), icon: 'i-lucide-plus', activeClass: 'bg-primary! text-on-primary!', exact: false },
  { to: '/linija/nov', label: t('nav.entry'), sub: t('modules.linija'), icon: 'i-lucide-plus', activeClass: 'bg-info! text-inverted!', exact: false },
])

watch(
  () => route.fullPath,
  () => (menuOpen.value = false),
)

watch(
  () => appStore.isLoggedIn(),
  (loggedIn) => {
    if (!loggedIn) menuOpen.value = false
  },
)
</script>
